/* eslint-disable no-useless-return */

import { FC, useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { translate } from 'translations';
import { coreService } from 'network-utils';
import { selectToken } from '@redux/slices/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserLanguages, getUserLearningPath } from '@queries/core/learningPath';
import { showAlert } from '@redux/slices/informationSlice';
import ProgramLanguageSelection from './programLanguageSelection';

const ProgramLanguageSelectionContainer: FC<ProgramLanguageSelectionContainerProps> = (
    props: ProgramLanguageSelectionContainerProps
) => {
    const { onClose } = props;
    const [isSelectingLanguages, setIsSelectingLanguages] = useState<boolean>(false);
    const token = useSelector(selectToken);
    const [userLanguages, setUserLanguages] = useState<any>();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const { data, isLoading } = useGetUserLanguages(token);

    useEffect(() => {
        if (!data) return;
        setUserLanguages({ ...data });
    }, [data]);

    const performSelectLanguages = async (input: {
        categories: any;
    }): Promise<{ success: boolean; error?: string }> => {
        const categories: any = {};
        for (const outerKey in input.categories) {
            // eslint-disable-next-line no-prototype-builtins
            if (input.categories.hasOwnProperty(outerKey)) {
                const innerObj = input.categories[outerKey];
                const sortedKeys = Object.keys(innerObj).sort((a, b) => innerObj[a] - innerObj[b]);
                categories[outerKey] = sortedKeys;
            }
        }
        const selectLanguagesResponse = await coreService.learningPathApi.selectLanguages(token, categories);
        return selectLanguagesResponse;
    };

    const generalErrorText = translate('generalError');

    const showError = () => {
        dispatch(
            showAlert({
                value: generalErrorText,
                status: 'error'
            })
        );
    };

    const { mutate: mutateSelectLangues } = useMutation(performSelectLanguages, {
        onSuccess: response => {
            setIsSelectingLanguages(false);
            if (!response?.success) {
                showError();
                onClose();
                return;
            }
            queryClient.invalidateQueries(getUserLearningPath);
            onClose();
        },
        onError: () => {
            setIsSelectingLanguages(false);
            showError();
            onClose();
        }
    });

    const onSelectLangues = (languages: any) => {
        if (isSelectingLanguages) return;

        setIsSelectingLanguages(true);
        mutateSelectLangues({ categories: languages });
    };

    return <ProgramLanguageSelection onSelect={onSelectLangues} userLanguages={userLanguages} isLoading={isLoading} />;
};

interface ProgramLanguageSelectionContainerProps {
    onClose: Function;
}

export default ProgramLanguageSelectionContainer;
